"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _apiKeys = _interopRequireDefault(require("./api-keys"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Users = /*#__PURE__*/function () {
  function Users(registry) {
    (0, _classCallCheck2["default"])(this, Users);
    this._api = registry;
    this.ApiKeys = new _apiKeys["default"](registry.UserAccess, {
      parentRoutes: {
        get: 'user_ids.user_id',
        list: 'user_ids.user_id',
        create: 'user_ids.user_id',
        update: 'user_ids.user_id'
      }
    });
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Users, [{
    key: "_addState",
    value: function _addState(fieldMask, user) {
      // Ensure to set STATE_REQUESTED if needed, which gets stripped as null
      // value from the backend response.
      if (fieldMask && fieldMask.field_mask.paths.includes('state') && !('state' in user)) {
        user.state = 'STATE_REQUESTED';
      }

      return user;
    }
  }, {
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var _this = this;

        var fieldMask, response, users;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context.next = 3;
                return this._api.UserRegistry.List(undefined, _objectSpread(_objectSpread({}, params), fieldMask));

              case 3:
                response = _context.sent;
                users = _marshaler["default"].payloadListResponse('users', response);
                users.users.map(function (user) {
                  return _this._addState(fieldMask, user);
                });
                return _context.abrupt("return", users);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(params, selector) {
        var _this2 = this;

        var fieldMask, response, users;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.EntityRegistrySearch.SearchUsers(undefined, _objectSpread(_objectSpread({}, params), fieldMask));

              case 3:
                response = _context2.sent;
                users = _marshaler["default"].payloadListResponse('users', response);
                users.users.map(function (user) {
                  return _this2._addState(fieldMask, user);
                });
                return _context2.abrupt("return", users);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function search(_x3, _x4) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(id, selector) {
        var fieldMask, response, user;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context3.next = 3;
                return this._api.UserRegistry.Get({
                  routeParams: {
                    'user_ids.user_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context3.sent;
                user = this._addState(fieldMask, _marshaler["default"].payloadSingleResponse(response));
                return _context3.abrupt("return", user);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getById(_x5, _x6) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(id) {
        var response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.UserRegistry.Delete({
                  routeParams: {
                    user_id: id
                  }
                });

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteById(_x7) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "purgeById",
    value: function () {
      var _purgeById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(id) {
        var response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.UserRegistry.Purge({
                  routeParams: {
                    user_id: id
                  }
                });

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function purgeById(_x8) {
        return _purgeById.apply(this, arguments);
      }

      return purgeById;
    }()
  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id, patch) {
        var mask,
            response,
            result,
            user,
            _result,
            _args6 = arguments;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                mask = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : _marshaler["default"].fieldMaskFromPatch(patch);
                _context6.next = 3;
                return this._api.UserRegistry.Update({
                  routeParams: {
                    'user.ids.user_id': id
                  }
                }, {
                  user: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                response = _context6.sent;
                result = _marshaler["default"].unwrapUser(response); // Get new profile picture value if a new picture was uploaded, deleted, or
                // the primary email address was changed (in case of Gravar usage).

                if (!(mask.includes('profile_picture') || mask.includes('primary_email_address'))) {
                  _context6.next = 11;
                  break;
                }

                _context6.next = 8;
                return this.getById(id, ['profile_picture']);

              case 8:
                user = _context6.sent;
                _result = _marshaler["default"].unwrapUser(response);
                _result.profile_picture = user.profile_picture;

              case 11:
                return _context6.abrupt("return", result);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function updateById(_x9, _x10) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(user, invitationToken) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.UserRegistry.Create(undefined, {
                  user: user,
                  invitation_token: invitationToken
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].unwrapUser(response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function create(_x11, _x12) {
        return _create.apply(this, arguments);
      }

      return create;
    }() // Miscellaneous.

  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(userId) {
        var result;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.UserAccess.ListRights({
                  routeParams: {
                    user_id: userId
                  }
                });

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getRightsById(_x13) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }()
  }, {
    key: "updatePasswordById",
    value: function updatePasswordById(id, payload) {
      return this._api.UserRegistry.UpdatePassword({
        routeParams: {
          'user_ids.user_id': id
        }
      }, {
        "new": payload["new"],
        old: payload.old,
        revoke_all_access: payload.revoke_all_access
      });
    }
  }, {
    key: "createTemporaryPassword",
    value: function createTemporaryPassword(id) {
      return this._api.UserRegistry.CreateTemporaryPassword({
        routeParams: {
          'user_ids.user_id': id
        }
      });
    }
  }]);
  return Users;
}();

var _default = Users;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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